module.exports = __webpack_public_path__ + "media/images/FFE-520-61c0da68de44e72e05578910d20b0f24.png";